import { render } from "./Modificar.vue?vue&type=template&id=dab1ab74&scoped=true"
import script from "./Modificar.vue?vue&type=script&lang=js"
export * from "./Modificar.vue?vue&type=script&lang=js"

import "./Modificar.vue?vue&type=style&index=0&id=dab1ab74&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab1ab74"]])

export default __exports__